// @ts-nocheck
import { fabric } from 'fabric';

let EventPosition;

(function () {
  const STROKE = {
    strokeWidth: 2,
    selectable: false,
    hasBorders: false,
    stroke: 'red',
    originX: 'center',
    originY: 'center',
    hoverCursor: 'arrow',
  };

  EventPosition = function (cv: any, sampleIndex: any, offsetX: any, config: any) {
    this.type = 'EventPosition';
    this.canvas = cv;
    this.config = config;
    this.isVisible = true;
    this.xr = sampleIndex;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.x = this.xr > offsetX ? (this.xr - offsetX) / this.spp : this.xr / this.spp;
  };

  EventPosition.prototype.draw = function () {
    this.l = new fabric.Line([this.x, 0, this.x, this.config.height], STROKE);
    this.l.id = 'l';
    this.rect = new fabric.Rect({
      left: this.x - this.config.samplingRate / this.spp,
      top: 0,
      width: (2 * this.config.samplingRate) / this.spp,
      height: this.config.height,
      fill: 'rgba(255,0,0,0.25)',
      selectable: false,
      hasBorders: false,
      hoverCursor: 'arrow',
    });
    this.rect.id = 'rect';
    this.canvas.add(this.l, this.rect);
  };

  EventPosition.prototype.render = function () {
    this.canvas.renderAll();
  };

  EventPosition.prototype.update = function (_delta: any) {
    // Can not modify this object
  };

  EventPosition.prototype.updateConfig = function (config: any, offsetX: any) {
    this.config = config;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.x = (this.xr - offsetX) / this.spp;

    this.l.set({ x1: this.x, x2: this.x, y2: this.config.height });
    this.l.setCoords();
    const leftVal = this.x - this.config.samplingRate / this.spp;
    this.rect.set({
      left: leftVal,
      width: (2 * this.config.samplingRate) / this.spp,
      height: this.config.height,
    });
    this.rect.setCoords();

    if (
      (leftVal < 0 || leftVal > config.width) &&
      (leftVal + this.rect.width < 0 || leftVal + this.rect.width > config.width)
    ) {
      this.isVisibility(false);
    } else {
      this.isVisibility(true);
    }
  };

  EventPosition.prototype.scroll = function (offsetX: any) {
    this.x = (this.xr - offsetX) / this.spp;

    this.l.set({ x1: this.x, x2: this.x });
    this.l.setCoords();
    const leftVal = this.x - this.config.samplingRate / this.spp;
    this.rect.set({
      left: leftVal,
    });
    this.rect.setCoords();

    if (
      (leftVal < 0 || leftVal > this.config.width) &&
      (leftVal + this.rect.width < 0 || leftVal + this.rect.width > this.config.width)
    ) {
      this.isVisibility(false);
    } else {
      this.isVisibility(true);
    }
  };

  EventPosition.prototype.isSelected = function () {
    return false; // Can not select this annotation
  };

  EventPosition.prototype.select = function () {
    // Can not select this annotation
  };

  EventPosition.prototype.deselect = function () {
    // Can not deselect this annotation
  };

  EventPosition.prototype.isVisibility = function (isVisibility: any) {
    this.l.visible = isVisibility;
    this.rect.visible = isVisibility;
    this.isVisible = isVisibility;
  };

  EventPosition.prototype.getJSONObject = function () {
    return {
      type: this.type,
      position: this.xr,
    };
  };

  EventPosition.prototype.import = function () {
    // This object import by create instance
  };
})();

export { EventPosition };
export default { EventPosition };
